import { BaseModel } from "sjs-base-model";

export default class ValoriModel extends BaseModel {
    public readonly percentage: number = 0;
    public readonly amount: number = 0;

    constructor(data: Partial<ValoriModel>) {
        super();

        this.update(data);
    }
}
